import React, { useState, useEffect, useContext } from "react"

import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import UserContext from "../../../../../context/UserContext"

import AtcAreaRadio from "./atcarearadio"
import RootCauses from "../rootcauses.js/rootcauses"
import Stories from "../stories/stories"
import Ingredients from "../../ingredients/ingredients"
import Results from "../../results-nova/results"
import FaqContact from "../faqcontact/faqcontact"

import ReferencesWild from "../../../global/references/references"

import ModalNova from "@nutrafol/nutrafol-ui-kit/dist/ModalNova"
import ListIngredients from "../../../nova/ingredients/listingredients"
import Nsfbanner from "../../../nova/nsf/nsfbannerpdp"

import { useIsFirstRender } from "../../../../../hooks/useIsFirstRender"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

export const CoreWrap = styled(Box)``

const CoreProduct = ({ data }) => {
  const isFirstRender = useIsFirstRender()
  const [showIngredientModal, setShowIngredientModal] = useState(false)
  const { atcAreaData } = data

  // Pass a single module UID
  ////////////////// HANDLE ATC DATA START
  const userState = useContext(UserContext)
  useEffect(() => {
    userState.setAtcData(atcAreaData)
    userState.setActiveOption(0)
    if (isFirstRender && !atcAreaData.savingstag) {
      setTimeout(() => {
        ///////////////// Product Viewed event /////////////////
        const pv = {
          core_category: atcAreaData.coreCategory,
          image_url: atcAreaData.mainimg,
          name: atcAreaData.name,
          product_gender: atcAreaData.options[0].product_gender,
          url: window.location.href,
        }
        segmentEvent("Product Viewed", pv)
      }, 2000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  ////////////////// HANDLE ATC DATA END

  return (
    <CoreWrap>
      <AtcAreaRadio data={atcAreaData} userState={userState} />
      <RootCauses data={data.rootCauses} />
      <Stories data={data.stories} />
      <Ingredients
        data={data.ingredients}
        onCtaClick={() => setShowIngredientModal(true)}
      />
      <Results data={data.results} />
      <div className={`vwo24829-variant2`}>
        <Nsfbanner />
      </div>
      <FaqContact data={data.questions} />
      <ReferencesWild data={data.references} />
      {showIngredientModal && (
        <ModalNova
          title={`What's inside ${data.ingredients.name}`}
          hideModal={() => setShowIngredientModal(false)}
        >
          <ListIngredients content={data.ingredients} />
        </ModalNova>
      )}
    </CoreWrap>
  )
}

export default CoreProduct
